import React, {Component, Fragment} from 'react';
import {Helmet} from 'react-helmet';

import SurveyPreview, {
    previewMeaningfulSelector
} from 'client/common/components/survey-preview/components/preview';
import {sendRumCounter} from 'client/common/utils/rum';
import I18N from 'assets/i18n/brandlift-project';

import {StateProps} from './types';

type ComponentProps = StateProps;

const i18n = I18N.root;

export default class PreviewPage extends Component<ComponentProps> {
    constructor(props: ComponentProps) {
        super(props);
        const {testBuckets} = props;

        sendRumCounter({
            page: 'quicksurvey.preview',
            meaningfulPaintSelector: previewMeaningfulSelector,
            testBuckets
        });
    }

    render() {
        const {slug} = this.props;

        return (
            <Fragment>
                <Helmet>
                    <title>{i18n.title}</title>
                    <meta name='viewport' content='width=device-width, initial-scale=1' />
                </Helmet>
                <SurveyPreview slug={slug} />
            </Fragment>
        );
    }
}
